import React, { useState, useEffect, useRef, useMemo } from 'react';
import AsyncSelect from "react-select/async";
import CreatableSelect from 'react-select/creatable';
import { customFetch } from '../apiClient';
import DiscountAuthorityDropdown from '../components/DiscountAuthorityDropdown';
import BatchDropdown from '../components/BatchDropdown';

const customStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    backgroundColor: "white",
    color: "black",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#ddd" : "white",
    color: "black",
  }),
};

const initItem = () => ({
  medID: null,
  medicineName: "",
  medicinecomposition: "",
  category: "",
  companyName: "",
  packSize: "",
  unit: "",
  mrp: 0,
  sRate: 0,
  expDate: "",
  gstP: 0,
  hsnCode: "",
  batchNo: "",
  availableQty: 0,
  leaf: 0,
  piece: 0,
  totSaleQtyInPc: 0,
  rate: 0,
  taxable: 0,
  cgst: 0,
  sgst: 0,
  grossAmount: 0,
  originalGrossAmount: 0,
  itemDiscount: 0,
  netAmount: 0,

});

const round2 = (v) => (Number.isFinite(v) ? parseFloat(v.toFixed(2)) : 0);
const getToken = () => sessionStorage.getItem("token");

const MedicineSaleEditModal = ({ show, saleData, onClose, onUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [patientType, setPatientType] = useState("MEDICUST");
  const [paymentMode, setPaymentMode] = useState("CASH");
  // Line ~56 (after existing states)
const [transactionType, setTransactionType] = useState("SALE"); // ✅ ADD THIS

  const [cashAmount, setCashAmount] = useState(0);
  const [upiAmount, setUpiAmount] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(0);
  const [disAuthority, setDisAuthority] = useState("");
  const [requestedBy, setRequestedBy] = useState("");
  // Existing states के पास जोड़ें
const [doctors, setDoctors] = useState([]);
const [selectedDoctor, setSelectedDoctor] = useState(null);
const [loadingDoctors, setLoadingDoctors] = useState(false);

  const [customerEntryMode, setCustomerEntryMode] = useState("SEARCH");
  const [customer, setCustomer] = useState({
    id: null,
    name: "",
    age: "",
    gender: "",
    mobileNo: "",
    address: "",
    type: "",
    uhidNo: "",
    ipdId: null,
  });

  const [batchOptions, setBatchOptions] = useState([]);
  const [loadingBatches, setLoadingBatches] = useState(false);
  const [currentItem, setCurrentItem] = useState(initItem());
  const [items, setItems] = useState([]);

  const [discountType, setDiscountType] = useState("PERCENT");
  const [discountValue, setDiscountValue] = useState(0);


  const formRef = useRef(null);
  const addButtonRef = useRef(null);
const medicineSelectRef = useRef(null);


const batchDropdownRef = useRef(null);
const leafInputRef = useRef(null);

// ✅ ADD THIS - Initial focus on modal open
useEffect(() => {
  if (show) {
    setTimeout(() => {
      const firstInput = formRef.current?.querySelector(
        'select, input:not([type="hidden"]), .react-select__input input'
      );
      if (firstInput) {
        firstInput.focus();
      }
    }, 300);
  }
}, [show]);


// ✅ ADD THIS - Keyboard navigation
useEffect(() => {
  if (!show) return;
  
  const handler = (e) => {
    if (formRef.current && e.target.closest("form") === formRef.current) {
      handleKeyDown(e);
    }
  };
  
  document.addEventListener("keydown", handler);
  return () => document.removeEventListener("keydown", handler);
}, [show]);



useEffect(() => {
    const fetchDoctors = async () => {
        try {
            setLoadingDoctors(true);
        const res = await customFetch(`/Employees/doctors`);
            if (res.ok) {
                const data = await res.json();
                const options = data.map(d => ({
                    value: d.id,
                    label: `${d.name} (${d.department?.departmentName || 'No Dept'})`,
                    originalName: d.name,
                    deptName: d.department?.departmentName || ''
                }));
                setDoctors(options);
            }
        } catch (err) {
            console.error("Error fetching doctors:", err);
        } finally {
            setLoadingDoctors(false);
        }
    };
    fetchDoctors();
}, []);

  // ✅ Load sale data on mount
  useEffect(() => {
    if (show && saleData) {
      loadSaleData(saleData);
    }
  }, [show, saleData]);

  const loadSaleData = (data) => {
    setPatientType(data.customerType || "MEDICUST");
    setTransactionType(data.transactionType || "SALE");
if (data.referredBy) {
        setSelectedDoctor({
            value: data.doctorId || data.referredBy, // ID हो तो ID, नहीं तो नाम ही value बनेगा
            label: data.referredBy // यही नाम बॉक्स में दिखेगा
        });
    } else {
        setSelectedDoctor(null);
    }
    setCustomer({
      id: data.customer?.id,
      name: data.customer?.name || "",
      age: data.customer?.age || "",
      gender: data.customer?.gender || "",
      mobileNo: data.customer?.mobileNo || "",
      address: data.customer?.address || "",
      type: data.customerType,
      uhidNo: data.customer?.uhidNo || "",
      ipdId: data.ipdId || null, 
    });
    setDiscountType(data.discountType || "PERCENT");
    setDiscountValue(data.discountValue || 0);
    setPaymentMode(data.payMode || "CASH");
    setPaidAmount(data.paidAmount || 0);
    setCashAmount(data.cash || 0);
    setUpiAmount(data.upi || 0);
    setDisAuthority(data.disAuthority || "");
    setRequestedBy(data.requestedBy || "");

    setItems(
      data.items?.map((item) => ({
        
        medID: item.medId,
        medicineName: item.medicine,
        medicinecomposition: item.medicinecomposition || "",
        category: item.category || "",
        companyName: item.companyName || "",
        packSize: item.packSize || "",
        unit: item.unit || "",
        batchNo: item.batchNo,
            expDate: item.expDate || "",
        leaf: item.leaf || 0,
        piece: item.piece || 0,
        totSaleQtyInPc: item.totSaleQtyInPc || item.qty || 0,
        mrp: item.mrp || 0,
        sRate: item.sRate || 0,
        gstP: item.gstP || 0,
        taxable: item.taxable || 0,
        cgst: item.cgst || 0,
        sgst: item.sgst || 0,
        grossAmount: item.grossAmount || item.totals || 0,
        itemDiscount: item.itemDiscount || 0,
        netAmount: item.netAmount || item.totals || 0,
        hsnCode: item.hsnCode || item.hsncode || "",
        availableQty: 0,
         rate: item.rate || 0, 
        
      })) || []
    );
    


    setError("");
    setSuccess("");
  };

  // Customer search
  const loadCustomerOptions = async (inputValue) => {
    if (!inputValue || inputValue.trim().length < 1) return [];

    let endpoint = "";
    let queryParam = "term";

    // ✅ FIX: Correct API endpoints and query parameter names
    if (patientType === "MEDICUST") { endpoint = "/MediCustDT/search"; }
    else if (patientType === "OPD") { endpoint = "/MediCustDT/searchopd"; }
    else if (patientType === "IPD") { 
      endpoint = "/Ipds/list"; 
      queryParam = "search"; // IPD API uses 'search'
    }

    try {
      const res = await customFetch(`${endpoint}?${queryParam}=${encodeURIComponent(inputValue.trim())}`);
      if (!res.ok) return [];
      const data = await res.json();

      return data.map((c) => ({
        // ✅ FIX: Extract proper ID based on type
        value: patientType === "IPD" ? c.ipD_ID : (c.customerID || c.id),
        label: `${c.customerName || c.name} | UHID: ${(c.uhiD_No || c.uhidNo) ?? "NA"} | Age: ${c.age ?? "NA"} | Mobile: ${c.mobileNo ?? "NA"}`,
        data: c,
      }));
    } catch {
      return [];
    }
  };
const handleCustomerSelect = (selected) => {
    if (!selected) {
      setCustomer({
        id: null,
        name: "",
        age: "",
        gender: "",
        mobileNo: "",
        address: "",
        type: "",
        uhidNo: "",
        ipdId: null,
      });
      return;
    }
    
    const c = selected.data;
    
    setCustomer({
      // ✅ FIX: Extract proper ID based on type
      id: patientType === "IPD" ? c.ipD_ID : (c.customerID || c.id),
      
      name: c.name || c.customerName || "",
      age: c.age || "",
      gender: c.gender || "",
      mobileNo: c.mobileNo || "",
      address: c.address || "",
      
      // ✅ FIX: Exact match from Swagger
      uhidNo: c.uhiD_No || c.uhidNo || "",
      
   ipdId: patientType === "IPD" ? selected.value : null,
      type: patientType,
    });
  };

  const handleCustomerInputChange = (e) => {
    const { name, value } = e.target;
    setCustomer((prev) => ({ ...prev, [name]: value }));
  };

  const handleCustomerModeChange = (mode) => {
    setCustomerEntryMode(mode);
    if (mode === "NEW") {
      setCustomer({
        id: null,
        name: "",
        age: "",
        gender: "",
        mobileNo: "",
        address: "",
        type: patientType,
        uhidNo: "",
      });
    }
    setError("");
  };

  // Medicine search
  const loadMedicineOptions = async (inputValue) => {
    if (!inputValue || inputValue.trim().length < 1) return [];
  try {
      // token line hata dein
      const res = await customFetch(`/MedicineDT/search?medicine=${encodeURIComponent(inputValue.trim())}`);
      if (!res.ok) return [];
      const data = await res.json();
      return data.map((m) => ({
        value: m.medID,
        label: m.medicine,
        data: m,
      }));
    } catch {
      return [];
    }
  };

  const loadBatchNumbers = async (medID) => {
    if (!medID) {
      setBatchOptions([]);
      return;
    }
    setLoadingBatches(true);
  try {
      // token line hata dein
      const res = await customFetch(`/MedicineBatch/batches/${medID}?hid=1&frid=1`);
      if (!res.ok) {
        setBatchOptions([]);
        return;
      }
      const data = await res.json();
      const options = data.map((batch) => ({
        value: batch.batchNo,
        label: `${batch.batchNo} (Avail: ${batch.balance})`,
        balance: batch.balance,
         expDate: batch.expDate || "", 
            mrp: batch.mrp,          // ✅ Add
            sRate: batch.sRate,      // ✅ Add
            saleDis: batch.saleDis
      }));
      setBatchOptions(options);
    } catch {
      setBatchOptions([]);
    } finally {
      setLoadingBatches(false);
    }
  };

const handleMedicineSelect = async (selected) => {
    if (!selected) {
        setCurrentItem(initItem);
        setBatchOptions([]);
        return;
    }

    const m = selected.data;
    setCurrentItem({
        ...initItem,
        medID: m.medID,
        medicineName: m.medicine,
        medicinecomposition: m.mediInUnit,
        category: m.categoryName,
        companyName: m.brandName,
        packSize: m.iUnit,
        unit: m.mUnit,
        mrp: m.mrp || 0,
        sRate: m.sRate || 0,
        gstP: m.gstp || 0,
        hsnCode: m.hsncode || m.hsnCode,
        mrp: '',     
        sRate: '',  
        batchNo: '',
        availableQty: 0
    });

    await loadBatchNumbers(m.medID);

    // ✅ CHANGE: Old batchSelectRef -> New batchDropdownRef
    setTimeout(() => {
        if (batchDropdownRef.current) {
            batchDropdownRef.current.focus();
        }
    }, 200);
};



useEffect(() => {
  if (!show) {
    setCurrentItem(initItem());
    setBatchOptions([]);
    setLoadingBatches(false);
    setItems([]);
    setError("");
    setSuccess("");
  }
}, [show]);

const handleKeyDown = (e) => {
    const isInsideAsyncSelect = 
        e.target.closest('.react-select__control') ||
        e.target.classList?.contains('react-select__input');
    
    if (isInsideAsyncSelect && e.key === 'Enter') return;

    const isReactSelectMenuOpen = document.querySelector('.react-select__menu');
    if (isReactSelectMenuOpen) return;

    // ✅ ADD THESE CHECKS
    const activeBatchDropdown = e.target.closest('[data-batch-dropdown="true"]');
    if (activeBatchDropdown) return;

    const batchPanelOpen = document.querySelector('.batch-dropdown-panel');
    if (batchPanelOpen) return;

  // ✅ FIX: tabIndex="-1" wale elements ko EXCLUDE karo
  const focusableElements = formRef.current?.querySelectorAll(
    'input:not([disabled]):not([readonly]):not([type="hidden"]):not([tabindex="-1"]), ' +
    '.react-select__input input:not([disabled]):not([readonly]):not([type="hidden"]), ' +
    'select:not([disabled]):not([tabindex="-1"]), ' +
    'textarea:not([disabled]):not([readonly]), ' +
    'button:not([disabled]):not([tabindex="-1"])'  // ✅ YE ADD KIYA
  );

  if (!focusableElements || focusableElements.length === 0) return;
  const currentIndex = Array.from(focusableElements).indexOf(e.target);

  const isAddButton = 
    e.target.textContent?.includes("Add Medicine") ||
    e.target.classList?.contains('add-medicine-btn') ||
    e.target.closest('button')?.textContent?.includes("Add Medicine");

  if (e.key === "Tab") {
    return; // Browser default
  }

  if (e.key === "Enter") {
    if (isAddButton) {
      e.preventDefault();
      handleAddItem();
      return;
    }

    // Last field = Form submit
    if (currentIndex === focusableElements.length - 1) {
      e.preventDefault();
      e.target.closest("form").requestSubmit();
      return;
    }

    // Otherwise next field
    e.preventDefault();
    const nextIndex = Math.min(focusableElements.length - 1, currentIndex + 1);
    focusableElements[nextIndex]?.focus();
  }
};



// ✅ ADD THIS
const handleBatchSelectCustom = (batch) => {
    if (!batch) {
        setCurrentItem(prev => ({
            ...prev,
            batchNo: '',
            availableQty: 0,
            expDate: '',
            mrp: '',
            sRate: ''
        }));
        return;
    }

    const updatedItem = {
        ...currentItem,
        batchNo: batch.value,
        expDate: batch.expDate,
        availableQty: batch.balance,
        mrp: batch.mrp,
        sRate: batch.sRate
    };
    
    recalcItem(updatedItem);
    setCurrentItem(updatedItem);
    
    // ✅ Focus Leaf field
    setTimeout(() => {
        if (leafInputRef.current) {
            leafInputRef.current.focus();
            leafInputRef.current.select();
        }
    }, 100);
};


  // Line ~381 (replace existing recalcItem)
const recalcItem = (item, mode = transactionType) => {  // ✅ ADD mode parameter
  const packSize = parseFloat(item.packSize) || 1;
  const leaf = parseFloat(item.leaf) || 0;
  const piece = parseFloat(item.piece) || 0;
  const sRate = parseFloat(item.sRate) || 0;
  const gstP = parseFloat(item.gstP) || 0;

  // ✅ ADD MULTIPLIER LOGIC
  const multiplier = mode === "RETURN" ? -1 : 1;

  const totSaleQtyInPc = (leaf * packSize + piece) * multiplier;
  item.totSaleQtyInPc = round2(totSaleQtyInPc);

  const rate = (sRate * Math.abs(totSaleQtyInPc)) / packSize * multiplier;
  const gross = round2(rate);

  const taxable = (gross * 100) / (100 + gstP);
  const cgst = (taxable * gstP) / 200;
  const sgst = (taxable * gstP) / 200;

  item.rate = round2(rate);
  item.taxable = round2(taxable);
  item.cgst = round2(cgst);
  item.sgst = round2(sgst);
  item.grossAmount = gross;
  item.originalGrossAmount = gross;
  item.itemDiscount = 0;
  item.netAmount = gross;
};

const handleItemChange = (e) => {
  const { name, value } = e.target;
  const newItem = { ...currentItem, [name]: value };
  recalcItem(newItem, transactionType); // ✅ Pass transactionType
  setCurrentItem(newItem);
};
// Line ~401
const handleAddItem = () => {
  if (!currentItem.medID) {
    setError("Please select a medicine.");
    return;
  }
  if (!currentItem.batchNo) {
    setError("Please select a batch number.");
    return;
  }
  
  const absQty = Math.abs(Number(currentItem.totSaleQtyInPc)); // ✅ ADD
  
  if (absQty <= 0) {  // ✅ CHANGE THIS
    setError("Quantity must be greater than 0.");
    return;
  }
  
  // ✅ ONLY SALE MODE MEIN STOCK CHECK
  if (transactionType === "SALE" && absQty > Number(currentItem.availableQty)) {
    setError("Sale quantity cannot exceed available quantity.");
    return;
  }

  setError("");
  
  const itemToAdd = { ...currentItem };
  recalcItem(itemToAdd, transactionType); // ✅ Pass transactionType
  
  setItems((prev) => [...prev, itemToAdd]);
  setCurrentItem(initItem());
  setBatchOptions([]);
  setLoadingBatches(false);
  setCustomerEntryMode("SEARCH");
  
  setTimeout(() => {
    if (medicineSelectRef.current) {
      medicineSelectRef.current.focus();
    }
  }, 150);
};


  const handleRemoveItem = (index) => {
    setItems((prev) => prev.filter((_, i) => i !== index));




    
  };
// Line ~421
const handleEditRowToForm = async (index) => {
  const row = items[index];
  if (!row) return;

  setCurrentItem(row);
  setItems(prev => prev.filter((_, i) => i !== index));
  const editItem = { ...row };
  recalcItem(editItem, transactionType); // ✅ Pass transactionType

  if (row.medID) {
    await loadBatchNumbers(row.medID);
  }

  setTimeout(() => {
    const batch = batchOptions.find(b => b.value === row.batchNo);
    if (batch) {
      setCurrentItem(prev => ({
        ...prev,
        batchNo: row.batchNo,
        mrp: batch.mrp || row.mrp,
        sRate: batch.sRate || row.sRate
      }));
    } else {
      setCurrentItem(prev => ({
        ...prev,
        batchNo: row.batchNo,
        mrp: row.mrp,
        sRate: row.sRate
      }));
    }
  }, 150);

  setError('');
  setSuccess('');
};


// Add this AFTER existing useEffect for loadSaleData
useEffect(() => {
  if (!show) {
    // 🔥 COMPLETE FORM RESET on modal close
    setCurrentItem(initItem());           // Medicine fields CLEAR
    setBatchOptions([]);                  // Batch dropdown CLEAR  
    setLoadingBatches(false);             // Loading spinner OFF
    setItems([]);                         // Items table CLEAR
    setError("");                         // Error CLEAR
    setSuccess("");                       // Success CLEAR
    setCustomerEntryMode("SEARCH");       // Customer mode DEFAULT
    setCustomer({                         // Customer fields CLEAR
      id: null, name: "", age: "", gender: "",
      mobileNo: "", address: "", type: "", uhidNo: "",ipdId: null
    });
    setSelectedDoctor(null);
    setDiscountType("PERCENT");
    setDiscountValue(0);
  }
}, [show]);


const totals = useMemo(() => {
  if (items.length === 0) {
    return {
      totalTaxable: 0,
      totalCgst: 0,
      totalSgst: 0,
      totalGrossAmount: 0,
      totalDiscount: 0,
      totalNetAmount: 0,
      displayItems: [],  // ✅ Table ke liye empty array
    };
  }

  const totalOriginalGross = items.reduce(
    (sum, it) => sum + parseFloat(it.originalGrossAmount || it.grossAmount || 0), 0
  );

  let totalDiscountAmount = 0;
  if (discountType === "PERCENT") {
    totalDiscountAmount = (totalOriginalGross * parseFloat(discountValue || 0)) / 100;
  } else {
    totalDiscountAmount = parseFloat(discountValue || 0);
  }

  const displayItems = items.map((item) => {
    const itemOriginalGross = parseFloat(item.originalGrossAmount || item.grossAmount || 0);
    const gstP = parseFloat(item.gstP) || 0;
    const proportion = totalOriginalGross > 0 ? itemOriginalGross / totalOriginalGross : 0;
    
    const itemDiscount = round2(totalDiscountAmount * proportion);
    const newGross = round2(itemOriginalGross - itemDiscount);
    const newTaxable = round2((newGross * 100) / (100 + gstP));
    const newCgst = round2((newTaxable * gstP) / 200);
    const newSgst = round2((newTaxable * gstP) / 200);

    return {
      ...item,
      itemDiscount,
     grossAmount: itemOriginalGross,
      taxable: newTaxable,
      cgst: newCgst,
      sgst: newSgst,
      netAmount: newGross,
    };
  });

  return {
    totalTaxable: round2(displayItems.reduce((s, it) => s + parseFloat(it.taxable || 0), 0)),
    totalCgst: round2(displayItems.reduce((s, it) => s + parseFloat(it.cgst || 0), 0)),
    totalSgst: round2(displayItems.reduce((s, it) => s + parseFloat(it.sgst || 0), 0)),
    totalGrossAmount: round2(totalOriginalGross),
    totalDiscount: round2(totalDiscountAmount),
    totalNetAmount: round2(displayItems.reduce((s, it) => s + parseFloat(it.netAmount || 0), 0)),
    displayItems,  // ✅ Table me discount values ke liye
  };
}, [items, discountType, discountValue]);


  // Payment calculation
  useEffect(() => {
    if (paymentMode === "CASH") {
      setPaidAmount(parseFloat(cashAmount || 0));
    } else if (paymentMode === "UPI") {
      setPaidAmount(parseFloat(upiAmount || 0));
    } else if (paymentMode === "BOTH") {
      setPaidAmount(
        parseFloat(cashAmount || 0) + parseFloat(upiAmount || 0)
      );
    } else if (paymentMode === "CREDIT") {
      setPaidAmount(0);
    }
  }, [paymentMode, cashAmount, upiAmount]);




  useEffect(() => {
    if (items.length === 0) {
      setDueAmount(0);
      return;
    }
    const totalNet = totals.totalNetAmount;
    const paid = parseFloat(paidAmount || 0);
    const due = totalNet - paid;
    setDueAmount(due > 0 ? due : 0);
  }, [paidAmount, totals.totalNetAmount, items.length]);

// ✅ ADD THIS useEffect (after existing useEffects):
useEffect(() => {
  // Auto-set availableQty when batchOptions change + currentItem has batchNo
  if (batchOptions.length > 0 && currentItem.batchNo && currentItem.availableQty === 0) {
    const batch = batchOptions.find(b => b.value === currentItem.batchNo);
    if (batch && batch.balance !== currentItem.availableQty) {
      setCurrentItem(prev => ({
        ...prev,
        availableQty: batch.balance
      }));
    }
  }
}, [batchOptions, currentItem.batchNo]);




  // Update sale
  const handleUpdateSale = async (e) => {
    e.preventDefault();

    if (customerEntryMode === "SEARCH" && !customer.id) {
      setError("Please select a customer or switch to Add New Customer.");
      return;
    }
    if (customerEntryMode === "NEW") {
      if (!customer.name || !customer.name.trim()) {
        setError("Customer Name is required.");
        return;
      }
      if (!customer.mobileNo || !customer.mobileNo.trim()) {
        setError("Mobile Number is required.");
        return;
      }
    }
    if (items.length === 0) {
      setError("At least add one medicine.");
      return;
    }
    
  

    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const token = getToken();

      const paymentStatus = 
  parseFloat(dueAmount) <= 0 ? "PAID" : 
  parseFloat(paidAmount) > 0 ? "PARTIAL" : 
  "PENDING";

const isExistingDoctor = selectedDoctor && doctors.some(d => d.value === selectedDoctor.value);
      const payload = {
      doctorId: isExistingDoctor ? selectedDoctor.value : null,
        referredBy: selectedDoctor 
            ? (isExistingDoctor ? (selectedDoctor.originalName ? `${selectedDoctor.originalName} (${selectedDoctor.deptName})` : selectedDoctor.label) : selectedDoctor.label)
            : (customer.uhidNo ? "Self" : ""),
        frid: 1,
        hid: 1,
          transactionType: transactionType,
        customerId: customerEntryMode === "SEARCH" ? customer.id : null,
        customerType: patientType,
         ipdId: patientType === "IPD" ? customer.ipdId : null,
        customerName: customer.name,
        mobileNo: customer.mobileNo,
        address: customer.address,
        age: customer.age ? parseInt(customer.age) : null,
        gender: customer.gender,
        billDate: new Date().toISOString().slice(0, 10),
        discountType,
        discountValue: parseFloat(discountValue || 0),
        discountAmount: totals.totalDiscount,
        totalGrossAmount: totals.totalGrossAmount,
        totalNetAmount: totals.totalNetAmount,
        payMode: paymentMode,
        cash: parseFloat(cashAmount || 0),
        upi: parseFloat(upiAmount || 0),
        paymentStatus: paymentStatus,
        paidAmount: parseFloat(paidAmount || 0),
        dueAmount: parseFloat(dueAmount || 0),
        disAuthority,
        requestedBy,
    items: totals.displayItems.map(it => ({
            medID: it.medID,
            batchNo: it.batchNo,
            expDate: it.expDate,
            
            // Integer fields
            leaf: parseInt(it.leaf) || 0,
            piece: parseInt(it.piece) || 0,
            totSaleQtyInPc: parseInt(it.totSaleQtyInPc) || 0,
            
            // Decimal fields - ALREADY COMPUTED with discount
            rate: parseFloat(it.rate) || 0,           // ✅ YE ADD KARNA THA!
            taxable: parseFloat(it.taxable) || 0,
            cgst: parseFloat(it.cgst) || 0,
            sgst: parseFloat(it.sgst) || 0,
            gstP: parseFloat(it.gstP) || 0,
            
            // ✅ FIX: originalGrossAmount use karo
            grossAmount: parseFloat(it.originalGrossAmount) || parseFloat(it.grossAmount) || 0,
            itemDiscount: parseFloat(it.itemDiscount) || 0,
            netAmount: parseFloat(it.netAmount) || 0,
            
            // Other fields
            sRate: parseFloat(it.sRate) || 0,
            mrp: parseFloat(it.mrp) || 0,
            
            hsnCode: it.hsnCode || it.hsncode || "",
          })),

      };

      console.log("Update payload:", payload);

    const res = await customFetch(`/MedicineSale/update/${saleData.billNo}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload),
        });
      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || "Failed to update sale.");
      }

      const data = await res.json();
      setSuccess(`✅ Sale updated: ${data.billNo}`);
      
      setTimeout(() => {
        onUpdate();
        onClose();
      }, 1500);
    } catch (err) {
      setError(err.message || "Update failed");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      tabIndex="-1"
    >
      <div className="container mt-4">
        <div className="card shadow">
  
            <div className="card-header bg-warning py-2">
              <div className="row">
                <h6 className="col-6">
                  {transactionType === "RETURN" ? "↩️ Edit Return" : "📝 Edit Sale"} - {saleData?.billNo}
                  <span className="badge bg-danger ms-2">{items.length} Items</span>
                  {transactionType === "RETURN" && (
                    <span className="badge bg-danger ms-2">RETURN MODE</span>
                  )}
                </h6>
                <div className="col-6 text-end">
                  <button type="button" className="btn-close" onClick={onClose}></button>
                </div>
              </div>
            </div>


          <form ref={formRef} onSubmit={handleUpdateSale}>
            <div className="modal-body p-3 fs-7">
              {error && <div className="alert alert-danger py-2">{error}</div>}
              {success && (
                <div className="alert alert-success py-2">{success}</div>
              )}

             
              {/* Customer Section */}
              <div className="border p-2 mb-1 rounded bg-light">
            

                <div className="row mb-0 mt-0 ">
                         
                  <div className="col-md-2">
                    <label className="form-label small mt-0 mb-0">Patient Type</label>
                    <select
                      className="form-select form-select-sm"
                      value={patientType}
                      onChange={(e) => {
                        setPatientType(e.target.value);
                        setCustomer({
                          id: null,
                          name: "",
                          age: "",
                          gender: "",
                          mobileNo: "",
                          address: "",
                          type: "",
                          uhidNo: "",
                        });
                      }}
                    >
                      <option value="MEDICUST">Medicine Customer</option>
                      <option value="OPD">OPD</option>
                      <option value="IPD">IPD</option>
                    </select>
                  </div>

                  <div className="col-md-3">
                    <label className="form-label small  mt-0 mb-0">Customer Entry</label>
                    <div className="btn-group w-100" role="group">
                      <button
                        type="button"
                        className={`btn btn-sm ${
                          customerEntryMode === "SEARCH"
                            ? "btn-primary"
                            : "btn-outline-primary"
                        }`}
                        onClick={() => handleCustomerModeChange("SEARCH")}
                      >
                        Search Existing
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm ${
                          customerEntryMode === "NEW"
                            ? "btn-success"
                            : "btn-outline-success"
                        }`}
                        onClick={() => handleCustomerModeChange("NEW")}
                      >
                        Add New
                      </button>
                    </div>
                  </div>
                   <div className="col-md-2">
                  <label className="form-label small fw-bold  mt-0 mb-0">Bill No</label>
                  <input
                    className="form-control form-control-sm bg-light"
                    value={saleData?.billNo || ""}
                    readOnly
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label small  mt-0 mb-0">Bill Date</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    defaultValue={saleData?.billDate?.slice(0, 10)}
                    readOnly
                  />
                </div>
                   {customerEntryMode === "SEARCH" && (
                      <>
                           <div className="col-md-2">
                        <label className="form-label small  mt-0 mb-0">UHID</label>
                        <input
                          className="form-control form-control-sm"
                          value={customer.uhidNo}
                          readOnly
                        />
                      </div>
                      <div className="col-md-1">
                        <label className="form-label small  mt-0 mb-0">Gender</label>
                        <input
                          className="form-control form-control-sm"
                          value={customer.gender}
                          readOnly
                        />
                      </div>
                      
                      </>)}
                </div>

                {/* SEARCH MODE */}
                {customerEntryMode === "SEARCH" && (
                  <>
                    <div className="row mb-3">
                      <div className="col-md-3">
                        <label className="form-label small  mt-0 mb-0">
                          Search Patient/Customer{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <AsyncSelect
                          key={patientType}
                          cacheOptions
                          loadOptions={loadCustomerOptions}
                          onChange={handleCustomerSelect}
                          placeholder="Type name/mobile to search..."
                          isClearable
                          styles={customStyles}
                          value={
                            customer.id
                              ? {
                                  value: customer.id,
                                  label: `${customer.name} | UHID: ${customer.uhidNo}`,
                                }
                              : null
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label small  mt-0 mb-0">Name</label>
                        <input
                          className="form-control form-control-sm"
                          value={customer.name}
                          readOnly
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label small  mt-0 mb-0">Mobile No</label>
                        <input
                          className="form-control form-control-sm"
                          value={customer.mobileNo}
                          readOnly
                        />
                      </div>
                        <div className="col-md-1">
                        <label className="form-label small  mt-0 mb-0">Age</label>
                        <input
                          className="form-control form-control-sm"
                          value={customer.age}
                          readOnly
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small  mt-0 mb-0">Address</label>
                        <input
                          className="form-control form-control-sm"
                          value={customer.address}
                          readOnly
                        />
                      </div>
                 
         
                    </div>

                   
                  </>
                )}

                {/* NEW MODE */}
                {customerEntryMode === "NEW" && (
                  <>
                    

                    <div className="row mb-3">
                      <div className="col-md-3">
                        <label className="form-label small  mt-0 mb-0">
                          Customer Name <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control form-control-sm"
                          name="name"
                          value={customer.name}
                          onChange={handleCustomerInputChange}
                          placeholder="Enter full name"
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label small mt-0 mb-0">
                          Mobile Number <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control form-control-sm"
                          name="mobileNo"
                          value={customer.mobileNo}
                          onChange={handleCustomerInputChange}
                          placeholder="10-digit mobile"
                          maxLength="10"
                        />
                      </div>
                      <div className="col-md-1">
                        <label className="form-label small mt-0 mb-0">Age</label>
                        <input
                          className="form-control form-control-sm"
                          name="age"
                          type="number"
                          value={customer.age}
                          onChange={handleCustomerInputChange}
                          placeholder="Age"
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label small mt-0 mb-0">Gender</label>
                        <select
                          className="form-select form-select-sm"
                          name="gender"
                          value={customer.gender}
                          onChange={handleCustomerInputChange}
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                        <div className="col-md-3">
                        <label className="form-label small mt-0 mb-0">Address</label>
                        <input
                          className="form-control form-control-sm"
                          name="address"
                          value={customer.address}
                          onChange={handleCustomerInputChange}
                          placeholder="Enter complete address"
                        />
                      </div>
                    </div>

                    
                  </>
                )}
                          <div className="row mb-0">
                      <div className="col-md-4">
                          <label className="form-label small mb-0">Referred By (Doctor)</label>
                          <CreatableSelect
                              isClearable
                              options={doctors}
                              value={selectedDoctor}
                              onChange={(opt) => setSelectedDoctor(opt)}
                              placeholder="Select or Type Doctor..."
                              formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                              isLoading={loadingDoctors}
                              styles={customStyles}
                          />
                      </div>
                  </div>
              </div>

              {/* Medicine Add Section */}
              <div className="border p-2 mb-1 rounded">
            

                <div className="row mb-1">
                  <div className="col-md-4">
  <label className="form-label small mt-0 mb-0">
    💊 Search Medicine <span className="text-danger">*</span>
  </label>
  
  {/* ✅ ADD WRAPPER DIV */}
  <div onKeyDown={(e) => {
    if (e.key === 'Enter') {
      const menu = document.querySelector('.react-select__menu');
      if (menu) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (!currentItem.medID && items.length > 0) return;
      if (currentItem.medID) return;
      e.preventDefault();
      e.stopPropagation();
    }
  }}>
    <AsyncSelect
      ref={medicineSelectRef} 
      cacheOptions
      loadOptions={loadMedicineOptions}
      onChange={handleMedicineSelect}
      placeholder="Start typing medicine name..."
      isClearable
      styles={customStyles}
      value={
        currentItem.medID
          ? {
              value: currentItem.medID,
              label: currentItem.medicineName,
            }
          : null
      }
    />
  </div>
</div>

                
                  <div className="col-md-3">
                    <label className="form-label small  mt-0 mb-0">Composition</label>
                    <input
                      className="form-control form-control-sm"
                      value={currentItem.medicinecomposition}
                      readOnly
                    />
                  </div>
                  <div className="col-md-1">
                    <label className="form-label small  mt-0 mb-0">Category</label>
                    <input
                      className="form-control form-control-sm"
                      value={currentItem.category}
                      readOnly
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label small  mt-0 mb-0">Company</label>
                    <input
                      className="form-control form-control-sm"
                      value={currentItem.companyName}
                      readOnly
                    />
                  </div>
                  <div className="col-md-1">
                    <label className="form-label small  mt-0 mb-0">Pack Size</label>
                    <input
                      className="form-control form-control-sm"
                      value={currentItem.packSize}
                      readOnly
                    />
                  </div>
                  <div className="col-md-1">
                    <label className="form-label small  mt-0 mb-0">GST %</label>
                    <input
                      className="form-control form-control-sm"
                      value={currentItem.gstP}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row g-2 mb-1">
                  
                  
                 
                
                  <div className="col-md-2">
                    <label className="form-label small  mt-0 mb-0">HSN Code</label>
                    <input
                      className="form-control form-control-sm"
                      value={currentItem.hsnCode}
                      readOnly
                    />
                  </div>

                  {currentItem.medID && (
                    <>
                      <div className="col-md-2">
                        <label className="form-label small  mt-0 mb-0">
                          Batch No <span className="text-danger">*</span>
                        </label>
                       <BatchDropdown
    ref={batchDropdownRef}
    options={batchOptions}
    value={currentItem.batchNo}
    onChange={handleBatchSelectCustom}
    loading={loadingBatches}
    disabled={batchOptions.length === 0}
/>

                      </div>

                         <div className="col-md-1">
                    <label className="form-label small  mt-0 mb-0">MRP</label>
                    <input
                      className="form-control form-control-sm bg-info"
                      value={currentItem.mrp}
                      readOnly
                    />
                  </div>
                   <div className="col-md-1">
                    <label className="form-label small  mt-0 mb-0">Sale Rate</label>
                    <input
                      className="form-control form-control-sm bg-info"
                      value={currentItem.sRate}
                      readOnly
                    />
                  </div>
                       <div className="col-md-2">
                        <label className="form-label small mt-0 mb-0">Expiry Date</label>
                        <input
                          className="form-control form-control-sm bg-warning"
                          value={
                            currentItem.expDate 
                              ? new Date(currentItem.expDate).toLocaleDateString('en-GB')
                              : ""
                          }
                          readOnly                   
                        />
                      </div>

                      <div className="col-md-2">
                        <label className="form-label small  mt-0 mb-0">
                          Available Qty
                        </label>
                        <input
                          className="form-control form-control-sm bg-warning"
                          value={currentItem.availableQty}
                          readOnly
                        />
                      </div>
                    </>
                  )}
                </div>

                {currentItem.batchNo && (
                  <div className="row g-2 mb-2">
                       <div className="col-md-2">
                        <label className="form-label small mt-0 mb-0">Leaf/Strip</label>
                        <input
                          ref={leafInputRef}
                          className={`form-control form-control-sm ${
                            transactionType === "RETURN" ? "bg-danger text-white" : ""
                          }`}
                          name="leaf"
                          type="number"
                          value={currentItem.leaf}
                          onChange={handleItemChange}
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label small mt-0 mb-0">Piece</label>
                        <input
                          className={`form-control form-control-sm ${
                            transactionType === "RETURN" ? "bg-danger text-white" : ""
                          }`}
                          name="piece"
                          type="number"
                          value={currentItem.piece}
                          onChange={handleItemChange}
                        />
                      </div>
                    <div className="col-md-1">
                      <label className="form-label small  mt-0 mb-0">Total Qty (Pcs)</label>
                      <input
                        className="form-control form-control-sm bg-info"
                        value={currentItem.totSaleQtyInPc}
                        readOnly
                      />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label small  mt-0 mb-0">Rate</label>
                      <input
                        className="form-control form-control-sm"
                        value={currentItem.rate}
                        readOnly
                      />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label small  mt-0 mb-0">Taxable</label>
                      <input
                        className="form-control form-control-sm"
                        value={currentItem.taxable}
                        readOnly
                      />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label small  mt-0 mb-0">CGST</label>
                      <input
                        className="form-control form-control-sm"
                        value={currentItem.cgst}
                        readOnly
                      />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label small  mt-0 mb-0">SGST</label>
                      <input
                        className="form-control form-control-sm"
                        value={currentItem.sgst}
                        readOnly
                      />
                    </div>
                        <div className="col-md-1">
      <label className="form-label small mt-0 mb-0">GST</label>
      <input
        className="form-control form-control-sm"
        value={(Number(currentItem.cgst || 0) + Number(currentItem.sgst || 0)).toFixed(2)}
        readOnly
      />
    </div>
                    <div className="col-md-1">
                      <label className="form-label small  mt-0 mb-0">Gross Amount</label>
                      <input
                        className="form-control form-control-sm"
                        value={currentItem.grossAmount}
                        readOnly
                      />
                    </div>
                    <div className="col-md-2 d-flex align-items-end">
                  <button
                    ref={addButtonRef}
                    type="button"
                    className="btn btn-success btn-sm w-100 add-medicine-btn"
                    onClick={handleAddItem}
                    onKeyDown={(e) => {  // ✅ ADD THIS
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleAddItem();
                      }
                    }}
                  >
                    ➕ Add Medicine
                  </button>
                </div>

                  </div>
                )}
              </div>

              {/* Items Table */}
           
              <div className="table-responsive mb-1" style={{ fontSize: "0.8rem" }}>
                <table className="table table-sm table-bordered table-hover align-middle text-center">
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>Medicine</th>
                      <th>Batch</th>
                        <th>Exp Date</th>
                      <th>Leaf</th>
                      <th>Piece</th>
                      <th>Tot Qty</th>
                      <th>Rate</th>
                      <th>Taxable</th>
                       <th>GST</th>
                  
                      <th>Gross</th>
                      <th className="bg-warning text-dark">Discount</th>
                      <th className="bg-success text-white">Net</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                 <tbody>
  {totals.displayItems?.length === 0 ? (
    <tr>
      <td colSpan="14" className="text-muted">No items added.</td>
    </tr>
  ) : (
    totals.displayItems.map((it, idx) => (  // ✅ totals.displayItems.map
      <tr key={idx}>
        <td>{idx + 1}</td>
        <td className="text-start">{it.medicineName}</td>
        <td>{it.batchNo}</td>
         <td>
              {it.expDate 
                ? new Date(it.expDate).toLocaleDateString('en-GB')
                : "-"}
            </td>
        <td>{it.leaf}</td>
        <td>{it.piece}</td>
        <td>{it.totSaleQtyInPc}</td>
        <td>{Number(it.rate || 0).toFixed(2)}</td>
        <td>{Number(it.taxable || 0).toFixed(2)}</td>
       <td>
              {(Number(it.cgst || 0) + Number(it.sgst || 0)).toFixed(2)}
            </td>
        <td>{Number(it.grossAmount || 0).toFixed(2)}</td>
        <td className="bg-warning fw-bold">
          {Number(it.itemDiscount || 0).toFixed(2)}
        </td>
        <td className="bg-success text-white fw-bold">
          {Number(it.netAmount || 0).toFixed(2)}    
        </td>
        <td>
          <button 
          className="btn btn-sm btn-primary me-1" 
          onClick={() => handleEditRowToForm(idx)}
           tabIndex="-1"
          >
            ✎
          </button>
          <button 
          className="btn btn-sm btn-danger"
          onClick={() => handleRemoveItem(idx)}
           tabIndex="-1">
            🗑
          </button>
        </td>
      </tr>
    ))
  )}
</tbody>

                </table>
              </div>

              {/* Summary + Payment */}
              {items.length > 0 && (
                <div className="mt-3 p-3 border rounded bg-light">
            

                  <div className="row mb-2">
                    <div className="col-md-2">
                      <label className="form-label small  mt-0 mb-0">Total Taxable</label>
                      <input
                        className="form-control form-control-sm"
                        value={totals.totalTaxable.toFixed(2)}
                        readOnly
                      />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label small  mt-0 mb-0">Total CGST</label>
                      <input
                        className="form-control form-control-sm"
                        value={totals.totalCgst.toFixed(2)}
                        readOnly
                      />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label small  mt-0 mb-0">Total SGST</label>
                      <input
                        className="form-control form-control-sm"
                        value={totals.totalSgst.toFixed(2)}
                        readOnly
                      />
                    </div>
                    <div className="col-md-1">
                      <label className="form-label small  mt-0 mb-0">Gross Amount</label>
                      <input
                        className="form-control form-control-sm"
                        value={totals.totalGrossAmount.toFixed(2)}
                        readOnly
                      />
                    </div>

                    <div className="col-md-2">
                      <label className="form-label small  mt-0 mb-0">Discount Type</label>
                      <select
                        className="form-select form-select-sm"
                        value={discountType}
                        onChange={(e) => setDiscountType(e.target.value)}
                      >
                        <option value="PERCENT">Percent</option>
                        <option value="AMOUNT">Amount</option>
                      </select>
                    </div>
                    <div className="col-md-1">
                      <label className="form-label small  mt-0 mb-0">
                        Discount {discountType === "PERCENT" ? "%" : "₹"}
                      </label>
                      <input
                        className="form-control form-control-sm"
                        type="number"
                        value={discountValue}
                        onChange={(e) => setDiscountValue(e.target.value)}
                        min="0"
                      />
                    </div>
                     <div className="col-md-2">
                      <label className="form-label small fw-bold  mt-0 mb-0">
                        Total Discount
                      </label>
                      <input
                        className="form-control form-control-sm fw-bold bg-warning"
                        value={totals.totalDiscount.toFixed(2)}
                        readOnly
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label small fw-bold  mt-0 mb-0">
                        Net Amount Payable
                      </label>
                      <input
                        className="form-control form-control-sm fw-bold bg-success text-white"
                        value={totals.totalNetAmount.toFixed(2)}
                        readOnly
                      />
                    </div>
                  </div>

                   <div className="row mb-0 mt-0">
                   

                    <div className="col-md-2">
                      <label className="form-label small  mt-0 mb-0">
                        Payment Mode <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select form-select-sm"
                        value={paymentMode}
                        onChange={(e) => {
                          setPaymentMode(e.target.value);
                          if (e.target.value === "CREDIT") {
                            setPaidAmount(0);
                            setCashAmount(0);
                            setUpiAmount(0);
                          }
                        }}
                      >
                        <option value="CASH">Cash</option>
                        <option value="UPI">UPI</option>
                        <option value="BOTH">Cash + UPI</option>
                        <option value="CARD">Card</option>
                        <option value="CREDIT">Credit (Due)</option>
                      </select>
                    </div>

                    {(paymentMode === "CASH" || paymentMode === "BOTH") && (
                      <div className="col-md-1">
                        <label className="form-label small  mt-0 mb-0">
                          Cash Amount <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control form-control-sm"
                          type="number"
                          value={cashAmount}
                          onChange={(e) => setCashAmount(e.target.value)}
                          min="0"
                          step="0.01"
                        />
                      </div>
                    )}

                    {(paymentMode === "UPI" || paymentMode === "BOTH") && (
                      <div className="col-md-1">
                        <label className="form-label small  mt-0 mb-0">
                          UPI Amount <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control form-control-sm"
                          type="number"
                          value={upiAmount}
                          onChange={(e) => setUpiAmount(e.target.value)}
                          min="0"
                          step="0.01"
                        />
                      </div>
                    )}

                    <div className="col-md-2">
                      <label className="form-label small fw-bold  mt-0 mb-0">
                        Total Paid Amount
                      </label>
                      <input
                        className="form-control form-control-sm fw-bold bg-primary text-white"
                        value={paidAmount.toFixed(2)}
                        readOnly
                      />
                    </div>

                    <div className="col-md-1">
                      <label className="form-label small fw-bold  mt-0 mb-0">
                        Due Amount
                      </label>
                      <input
                        className={`form-control form-control-sm fw-bold ${
                          dueAmount > 0
                            ? "bg-danger text-white"
                            : "bg-success text-white"
                        }`}
                        value={dueAmount.toFixed(2)}
                        readOnly
                      />
                    </div>
                      {discountValue > 0 && (
                   <>
                   
                      {/* <div className="col-md-3 ">
                  <label className="form-label small mt-0 mb-0">
                    Discount Authority <span className="text-danger">*</span>
                  </label>
                  <DiscountAuthorityDropdown
                     value={disAuthority}
                          onChange={(e) => setDisAuthority(e.target.value)}
                    name="discountAuthority"
                 
                  />
                  </div> */}


                  
                      <div className="col-md-3 ">
  <DiscountAuthorityDropdown
    value={disAuthority}  // ✅ State से directly bind
    onChange={(e) => setDisAuthority(e.target.value)}
    name="disAuthority"
    label="Discount Authority"  // ✅ Label pass karein
    showLabel={true}
    placeholder="Select Authority"
   
  />
</div>

                      <div className="col-md-2">
                        <label className="form-label small  mt-0 mb-0">
                          Requested By
                        </label>
                        <input
                          className="form-control form-control-sm"
                          value={requestedBy}
                          onChange={(e) => setRequestedBy(e.target.value)}
                          placeholder="Staff name"
                        />
                      </div>
                   </>
                  )}
                  </div>
                </div>
              )}

              {/* Payment Details */}
             
            </div>

            <div className="modal-footer py-2">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={onClose}
              >
                ❌ Cancel
              </button>
              <button
                type="submit"
                className="btn btn-success btn-sm px-4"
                disabled={loading || items.length === 0}
              >
                {loading ? "Updating..." : "✅ Update Sale"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MedicineSaleEditModal;
